<!-- routify:options preload="proximity" -->
<script lang="ts">
  window["C"].APP_NAME = "distributor";
  window["C"].userUrl = "/api/distributor/user";
  window["C"].salesforceChatContext = "distributor";
  import bootstrap from "@modern/services/boot/bootstrap";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import DistributorHeader from "@distributor/svelte/Components/Header.svelte";
  import Footer from "@shared/svelte/Components/Layout/Footer.svelte";
  import FlashWrapper from "@shared/svelte/Components/Flash/Wrapper.svelte";
  import DistributorSelector from "@distributor/svelte/Components/DistributorSelector.svelte";
  import distributorContext from "@modern/services/distributor_context";
  import userContext from "@modern/services/user_context";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { afterPageLoad, beforeUrlChange, page, url, goto } from "@roxi/routify";
  import { updatePageIds } from "@shared/services/event_tracking/page_id_tracking";
  import { DistributorStore } from "@distributor/svelte/Stores/DistributorStore";
  import AcceptTermsModal from "@shared/svelte/Components/AcceptTermsModal.svelte";
  import * as _ from "lodash";
  import { tick } from "svelte";
  import { shouldNotTrackAnywhere } from "@shared/services/internal_user_check_helpers";
  import Flash from "@shared/services/flashv2.js";

  const { trackPageView } = EventTracking;

  let user;
  let trueUser;
  let trueUserDisplayName;

  const hideOnPages = ["product_sheets", "storefronts", "order_info"];

  let hideDistributorSelector = false;
  const shouldHideDistributorSelector = page => {
    hideOnPages.some(p => {
      if (page.path.includes(p)) {
        hideDistributorSelector = true;
        return;
      }
    });
  };

  $afterPageLoad(_page => {
    trackPageView();
    shouldHideDistributorSelector(_page);
    doAcceptTermsModal();
    return true;
  });

  $beforeUrlChange((event, route) => {
    updatePageIds();
    return true;
  });

  const setWarnings = function () {
    const onboardingWarnings = distributorContext.getOnboardingWarnings();
    const matchingUser = onboardingWarnings?.current_user == user.id;
    if (onboardingWarnings?.warnings.length && matchingUser) {
      distributorContext.clearOnboardingWarnings();
      const msg =
        onboardingWarnings.warnings +
        " If you believe this is an error, please contact " +
        '<a href="https://support.provi.com/s/topic/0TODn000000YIMqOAO/distributor-sales-reps">Provi Support</a> for help resolving the issue.';
      Flash.now({ rawHtml: true, type: "warning", message: msg });
    }
  };

  let hasMultipleDistributors;
  let fixedHeader;
  let distributors;
  let currentDistributor;
  let showNav;

  const setup = function () {
    setWarnings();
    hasMultipleDistributors = distributorContext.hasMultipleDistributors();
    showNav = !$page.path.includes("preview_content");
    fixedHeader = showNav && (!hasMultipleDistributors || hideDistributorSelector);
    distributors = distributorContext.getAllDistributors();
    currentDistributor = distributorContext.getCurrentDistributor() || distributors[0];
    if (!window["$rootScope"].currentDistributor) {
      distributorContext.setCurrentDistributorContext(currentDistributor.distributor_id);
    }
    DistributorStore.set({
      currentDistributor: _.find(distributors, {
        distributor_id: currentDistributor.distributor_id,
      }),
      distributors: distributors,
    });
  };

  const load = async function () {
    updatePageIds();
    await bootstrap({ $page, $url, $goto });
    user = userContext.context.user;
    trueUser = userContext.context.trueUser;
    if (user && trueUser && user.id !== trueUser.id) {
      trueUserDisplayName = userContext.userNameString(trueUser);
    }
    setup();
  };

  const selectDistributor = function (distributorId) {
    DistributorStore.update(state => ({
      ...state,
      currentDistributor: _.find(distributors, { distributor_id: distributorId }),
    }));
    distributorContext.setDistributorReloadState(distributorId);
  };

  const doAcceptTermsModal = async function () {
    await tick();
    if (!userContext?.context?.user?.accepted_terms_at && !shouldNotTrackAnywhere()) {
      window["svelteModal"](AcceptTermsModal, {
        companyName: window["C"].COMPANY_NAME,
      });
    }
  };
</script>

{#await load()}
  <Spinner />
{:then}
  <div class="app-container background-gray">
    <div class="app-container__content">
      {#if showNav}
        <DistributorHeader {distributorContext} {user} {trueUserDisplayName} />
      {/if}

      {#if hasMultipleDistributors && !hideDistributorSelector}
        <div class="fixed-header-margin-distributor fizz-styles">
          <DistributorSelector {selectDistributor} {page} />
        </div>
      {/if}
      <div class={fixedHeader ? "fixed-header-margin-distributor" : ""}>
        <slot scoped={{ user: user }} />
      </div>
    </div>
    <FlashWrapper />
    <Footer />
  </div>
  <div id="programmatic-modal-container"></div>
{/await}
